<template>
  <v-chart
    class="chart"
    :option="option"
    autoresize/>
</template>

<script>
import VChart from 'vue-echarts'

export default {
  name: "ChartResignation",
  components: {
    VChart
  },
  props: {
    resignation: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      option: {
        title: {
          text: "Renuncias",
          left: "center"
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
        },
        series: [
          {
            name: 'Renuncias',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: parseInt(this.resignation.resignation), name: 'Ingresada' },
              { value: parseInt(this.resignation.incorporate), name: 'Aceptada' },
              { value: parseInt(this.resignation.refuseServel), name: 'Rechazada' },
            ]
          }
        ]
      }
    };
  }
}
</script>

<style scoped>
.chart {
  height: 550px;
}
</style>
